/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
campoExtraListApiDirectiva.$inject = [];
export default function campoExtraListApiDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'modelId': '=',
            'cargando': '=',
            'claseRow': '@'
        },
        template: require('./campos-extra-list-api.html'),
        controller: 'CamposExtraListApiCtrl as campExtListApi',
        bindToController: true
    }
}